import React from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import AccountSeriesItem from "../components/AccountSeriesItem";
import Button from "components/CustomButtons/Button.js";
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import Info from "../../components/Typography/Info";
import intl from "react-intl-universal";


class AccountCourse extends React.Component {


	render() {

		const series = this.props.data.map(data => {
			return (<AccountSeriesItem data={data}/>)
		});

		return (
			<div>
				<div>
					<h2>{intl.get('my_series')}: </h2>
				</div>
				<GridContainer>
					{series}
				</GridContainer>
				<GridContainer justify={"flex-end"} alignItems="center" style={{marginTop: '12px'}}>

						<Button
							href={"/plans"}
						color="info">
							<CreateNewFolderIcon/>&nbsp;&nbsp;&nbsp;{intl.get('see_more_series')}
						</Button>

				</GridContainer>
			</div>


		);
	}
}

export default AccountCourse